export default __webpack_public_path__ + "static/media/Humra_Tahir.ef8fbfaf.png";